import script from "./PaymentTerms.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentTerms.vue?vue&type=script&setup=true&lang=js"

import "./PaymentTerms.vue?vue&type=style&index=0&id=35734006&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35734006"]])

export default __exports__